import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class PageMetadataService {

  constructor(private titleService: Title) { }

  // Set page title
  setTitle(title: string): void {
    this.titleService.setTitle(title);
  }

  // Set page favicon
  setFavicon(faviconUrl: string): void {
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  }
}
